import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { CustomText } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { ColaboradoresScroll } from './apontamentoProducao.styled';

const HIRING_MODEL_MISMATCH_MODAL_TITLE = 'Divergência Horista / Mensalista';

/**
 * Modal para exibir divergências de modelo de contratação (Horista/Mensalista)
 */
export function ModalHiringModelMismatch({ visible, mismatches, onOk, onCancel }) {
  const mismatchesList = Array.isArray(mismatches) ? mismatches : [];
  const messageLines =
    mismatchesList.length > 0 ? mismatchesList.map((m) => `${m.cooperatorName} - ${m.field}: ${m.value}`) : [];

  return (
    <Modal
      centered
      width={560}
      title={
        <CustomText
          color="var(--text-grey-8)"
          fontSize={16}
        >
          {HIRING_MODEL_MISMATCH_MODAL_TITLE}
        </CustomText>
      }
      okText="Importar"
      cancelText="Cancelar"
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
    >
      <ColaboradoresScroll>
        <p>Os seguintes dados estão divergentes e não serão considerados na importação:</p>
        <ul>
          {messageLines.map((line, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={index}>{line}</li>
          ))}
        </ul>
        <p style={{ marginTop: '20px' }}>
          <b>Motivo:</b> Mensalistas não recebem horas e Horistas, dias trabalhados.
          <br />
          Você poderá utilizar os campos determinados ou Valor Adicional para concluir o fechamento.
        </p>
        <p>Gostaria de seguir com a importação?</p>
      </ColaboradoresScroll>
    </Modal>
  );
}

ModalHiringModelMismatch.propTypes = {
  visible: PropTypes.bool.isRequired,
  mismatches: PropTypes.arrayOf(
    PropTypes.shape({
      cooperatorName: PropTypes.string.isRequired,
      field: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ),
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

ModalHiringModelMismatch.defaultProps = {
  mismatches: [],
};
